import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';

import { ActionButtonVariants } from 'components/action-button';
import { ModalSize } from 'components/modal';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

import RatingStars from './rating-stars';
import {
  ButtonContainer,
  Description,
  DismissButton,
  ModalContent,
  ModalHead,
  ModalInner,
  StyledModal,
  StyledStars,
} from './styled';

const ModalRating: React.FC = () => {
  const { formatMessage } = useIntl();
  const [showModal, setShowModal] = useState(true);
  const AFTER_RATE_DELAY = 3000;
  const AMOUNT_STARS = 5;

  const onCloseModal = () => {
    setShowModal(false);
  };

  const onNotNowModal = () => {
    setShowModal(false);
  };

  const onRate = (stars: number) => {
    if (stars === AMOUNT_STARS) {
      closeModalOnRate();
    } else {
      setTimeout(() => {
        closeModalOnRate();
      }, AFTER_RATE_DELAY);
    }
  };

  const closeModalOnRate = () => {
    setShowModal(false);
    LocalStorage.setItem(StorageKeys.APP_RATING_SHOWN, true);
  };

  return (
    (showModal && (
      <StyledModal size={ModalSize.SMALL} data-testid="modal-app-rating" onDismiss={onCloseModal}>
        <ModalInner data-testid="modal-rating">
          <ModalHead>
            <h3>{formatMessage({ id: 'enjoyUsingOurApp' })}</h3>
          </ModalHead>
          <ModalContent>
            <Description>
              <StyledStars data-testid="rating-stars">
                <RatingStars onRate={onRate} />
              </StyledStars>
            </Description>
            <ButtonContainer>
              <DismissButton
                data-testid="notnow-button"
                variant={ActionButtonVariants.TEXT_ONLY}
                onClick={onNotNowModal}
              >
                {formatMessage({ id: 'notNow' })}
              </DismissButton>
            </ButtonContainer>
          </ModalContent>
        </ModalInner>
      </StyledModal>
    )) || <></>
  );
};

const ModalRatingWrapper: React.FC = () => {
  const [showModalDelayed, setShowModalDelayed] = useState(false);

  const enableModalRating = useFlag(LaunchDarklyFlag.ENABLE_APP_RATING_ON_ORDER_COMPLETED);
  const appRatingShown = LocalStorage.getItem(StorageKeys.APP_RATING_SHOWN);
  const SHOW_UP_DELAY = 3000;

  useEffect(() => {
    setTimeout(() => {
      setShowModalDelayed(true);
    }, SHOW_UP_DELAY);
  }, []);

  return showModalDelayed && enableModalRating && !appRatingShown ? <ModalRating /> : null;
};

export default ModalRatingWrapper;
